import { FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class RechazosTracesNavMenuItemViewModel {
    public CHEDPP: string;
}

export class RechazosTracesItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RechazosTracesItemViewModel[];
}

export class RechazosTracesItemViewModel {
    public CHEDPP: string;
    public PaisOrigen: string;
    public PaisDestino: string;
    public PaisEmision: string;
    public Exportador: string;
    public Importador: string;
    public FechaDecision: Date;
    /*public FechaPresentacion: Date;*/
    public Embalajes: ClassCodeClassNameViewModel[];
    public Productos: ClassCodeClassNameViewModel[];
    public FechaUltimaActualizacion: Date;
}

export class FilterSearchingRechazosTracesViewModel extends FilterSearchingBaseViewModel {
    public PaisOrigen: string;
    public PaisDestino: string;
    public PaisEmision: string;
    public CodigoTaric: string;
    public BusquedaExacta: boolean;
    public FechaDecisionDesde: Date;
    public FechaDecisionHasta: Date;
    public IsRechazo: boolean;
}

export class ClassCodeClassNameViewModel {
    public CodigoTaric: string;
    public Descripcion: string;
}

export class RechazosTracesParteIViewModel {
    public CHEDPP: string;

    public NombreExportador: string;
    public PaisExportador: string;
    public NombreImportador: string;
    public PaisImportador: string;
    public RefDocAduanero: string;
    public Referencia: string;
    //public NombrePCF: string;
    //public PaisPCF: string;
    public NombrePIF: string;
    public PaisPIF: string;
    public NombreOperador: string;
    public PaisOperador: string;
    public Documentos: CHEDDPPPartOneDocumentoViewModel[];
    public NotificacionPrevia: Date;
    public NombreLugarDestino: string;
    public PaisLugarDestino: string;
    public NombreMedioTrans: string;
    public TipoMedioTrans: string;
    public PaisMedioTrans: string;
    public DocumentoMedioTrans: string;
    public PaisOrigen: string;
    public PaisExpedicion: string;
    public NumeroContenedor: string;
    public NumeroPrecinto: string;
    public PrecintoOficial: string;
    public Finalidad: string;
    public Embalajes: CHEDPPPartOneEmbalajeViewModel[];
    public Productos: CHEDPPPartOneProductoViewModel[];
}

export class RechazosTracesParteIIViewModel {
    public CHEDPP: string;

    public ControlDocumentalCheck: boolean;
    public ControlDocumentalResult: string;
    public ControlIdentidadCheck: boolean;
    public ControlIdentidadResult: string;
    public ControlFisicoCheck: boolean;
    public ControlFisicoResult: string;
    public ControlCOICheck: boolean;
    public ControlCOIResult: string;
    public Conclusion: string;
    public FechaInspeccion: Date;
    public NombreInspector: string;
    public PaisInspector: string;
    public NombrePIF: string;
    public PaisPIF: string;
    public MedidasList: CHEDDPPPartTwoRechazoViewModel[];
    public MotivosList: CHEDDPPPartTwoRechazoViewModel[];
}

export class RechazosTracesNoCumplimientoViewModel {
    public CHEDPP: string;

    public MotivosList: CHEDPPMotivoRechazoViewModel[];
    public MedidasList: CHEDPPMedidaRechazoViewModel[];
    public ComentarioMedidas: string;
    public CiudadInspeccion: string;
    public CodigoISOInspeccion: string;
    public CodigoPostalInspeccion: string;
    public DireccionInspeccion: string;
    public NombreInspector: string;
    public PaisInspeccion: string;
    public FechaTipoInspeccion: Date;
    public PFC: string;
    public TipoLugarInspeccion: string;
    public TipoInspControlSeguimientoNoSintomas: string;
    public TipoInspControlSeguimientoSiSintomas: string;
    public TipoInspSupervisionPuestoInsp: string;
    public Unlocode: string;
    public Documentos: CHEDPPNCODocumentoViewModel[];
}

export class CHEDDPPPartOneDocumentoViewModel {
    public Nombre: string;
    public Numero: string;
    public Fecha: Date;
    public Pais: string;
    public Tipo: string;
    public Link: string;

    public DownloadButtonAvailable: boolean;
}

export class CHEDPPPartOneEmbalajeViewModel {
    public Taric: string;
    public Eppo: string;
    public Peso: number;
    public NumeroUnidades: number;
    public Recuento: string;
    public PaisOrigen: string;
    public NombreComun: string;
    public RetrievedUnitCodeWeight: string;
    public RetrievedUnitCodeQuantity: string;
}

export class CHEDPPPartOneProductoViewModel {
    public Taric: string;
    public Eppo: string;
    public NombreCientifico: string;
    public Tipo: string;
    public Peso: number;
    public Volumen: number;
    public NumeroBultos: number;
    public NumeroUnidades: number;
    public PaisOrigen: string;
    public NombreComun: string;
    public RetrievedUnitCodeWeight: string;
    public RetrievedUnitCodeQuantity: string;
    public RetrievedUnitCodeVolume: string;
}

export class CHEDDPPPartTwoRechazoViewModel {
    public Descripcion: string;
    public Extension: string;
}

export class CHEDPPNCOTipoInspeccionViewModel {
    public TipoInspSupervisionPuestoInsp: string;
    public TipoInspControlSeguimientoNoSintomas: string;
    public TipoInspControlSeguimientoSiSintomas: string;
    public FechaTipoInspeccion: Date;
}

export class CHEDPPMotivoRechazoViewModel {
    public IdRowMotivo = 0;

    public Descripcion: string;
    public Extension: string;
    public OrganismoNocivo: CHEDPPItemRechazoViewModel;
    public OrganismoNocivoNoEspecie: CHEDPPItemRechazoViewModel;
    public OrganismoNocivoNoReguladoUE: CHEDPPItemRechazoViewModel;
    public Observacion: string;

    public MotivoProductosList: CHEDPPItemRechazoViewModel[];
    public MotivoEmbalajesList: CHEDPPItemRechazoViewModel[];
}

export class CHEDPPMedidaRechazoViewModel {
    public IdRowMedida = 0;

    public Descripcion: string;
    public Extension: string;
    public FechaInicioCuarentena: Date;
    public FechaFinPrevistaCuarentena: Date;
    public FechaFinCuarentena: Date;
    public LugarCuarentena: string;
    public PaisCuarentena: string;

    public MedidaProductosList: CHEDPPItemRechazoViewModel[];
    public MedidaEmbalajesList: CHEDPPItemRechazoViewModel[];
}

export class CHEDPPItemRechazoViewModel {
    public Taric: string;
    public DescripcionOne: string;
    public DescripcionTwo: string;
}

export class CHEDPPNCODocumentoViewModel {
    public Nombre: string;
    public Referencia: string;
    public Fecha: Date;
    public Pais: string;
    public Tipo: string;
    public Link: string;

    public DownloadButtonAvailable: boolean;
}

export class TNTRetrievalAttachmentViewModel {
    public CHEDPP: string;
    public DocumentId: number;
    public FileName: string;
}
